<template>
	<div class="flex flex-col min-h-screen home">
		<SiteHeader />

		<div class="content">
			<div class="min-h-screen section-mainbanner">
				<div class="container flex items-center min-h-screen px-4 pt-40 pb-16 text-center text-white lg:text-left font-montserrat">
					<div class="flex flex-wrap items-center w-full">
						<div class="w-full px-4 mb-12 text-center lg:w-7/12 lg:mb-0">
							<h2 class="text-4xl font-semibold uppercase leading-tighter lg:text-6xl">Efficient, Reliable, and Safe Bus Transport Provider</h2>
						</div>
						<div class="w-full px-4 py-8 text-white lg:py-12 lg:px-8 bg-siteRed lg:w-5/12">
							<p class="mb-6 text-xl font-semibold leading-none text-center uppercase font-montserrat">Send Us Your Enquiry Today!</p>
							<!-- feedback.activamedia.com.sg script begins here -->
							<iframe allowTransparency="true" style="min-height:430px; height:inherit; overflow:auto;" width="100%" id="contactform123" name="contactform123" marginwidth="0" marginheight="0" frameborder="0" src="//feedback.activamedia.com.sg/my-contact-form-5661262.html"></iframe>
							<!-- feedback.activamedia.com.sg script ends here -->
						</div>
					</div>
				</div>
			</div>

			<div class="bg-gray-300 section-promo">
				<div class="container px-4 py-8 lg:py-16">
					<h2 class="mb-8 text-3xl font-semibold leading-tight text-center uppercase lg:text-5xl lg:mb-16 font-montserrat">Our Fleet of Buses</h2>

					<div class="flex flex-wrap">
						<div class="w-full mb-8 md:px-4 md:w-1/2">
							<div class="flex flex-col justify-start leading-tight">
								<div class="p-4 text-2xl font-semibold text-center text-white uppercase bg-siteRed font-montserrat">13-Seater Bus</div>
								<div class="h-full p-4 bg-white">
									<div class="flex flex-wrap">
										<div class="w-full h-64 mb-4 lg:mb-0 md:pr-2 md:w-1/2">
											<img class="object-cover object-center w-full h-full" src="@/assets/promo-13seater01.jpg">
										</div>
										<div class="w-full h-64 md:pl-2 md:w-1/2">
											<img class="object-cover object-center w-full h-full" src="@/assets/promo-13seater02.jpg">
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="w-full mb-8 md:px-4 md:w-1/2">
							<div class="flex flex-col justify-start leading-tight">
								<div class="p-4 text-2xl font-semibold text-center text-white uppercase bg-siteRed font-montserrat">45-Seater Bus</div>
								<div class="h-full p-4 bg-white">
									<div class="flex flex-wrap">
										<div class="w-full h-64 mb-4 lg:mb-0 md:pr-2 md:w-1/2">
											<img class="object-cover object-center w-full h-full" src="@/assets/promo-45seater01.jpg">
										</div>
										<div class="w-full h-64 md:pl-2 md:w-1/2">
											<img class="object-cover object-center w-full h-full" src="@/assets/promo-45seater02.jpg">
										</div>
									</div>
								</div>
							</div>
						</div>

					</div>

				</div>
			</div>

			<div class="section-services">
				<div class="container px-4 py-8 lg:py-16">
					<h2 class="mb-8 text-3xl font-semibold leading-tight text-center uppercase lg:text-5xl lg:mb-16 font-montserrat">Services</h2>

					<div class="flex flex-wrap">
						<div class="w-full mb-4 lg:pb-4 lg:w-1/2 lg:pr-4 lg:mb-0">
							<div class="w-full h-full lg:h-64 services-img"></div>
						</div>

						<div class="w-full lg:w-1/2 lg:pl-2">
							<div class="flex flex-wrap leading-tight text-center text-white font-montserrat">
								<div class="w-1/2 mb-4">
									<div class="p-3 mx-2 rounded-full bg-siteRed">
										One-way Transportation
									</div>
								</div>
								<div class="w-1/2 mb-4">
									<div class="p-3 mx-2 rounded-full bg-siteRed">
										Two-way Transportation
									</div>
								</div>
								<div class="w-1/2 mb-4">
									<div class="p-3 mx-2 rounded-full bg-siteRed">
										Shuttle Bus Service
									</div>
								</div>
								<div class="w-1/2 mb-4">
									<div class="p-3 mx-2 rounded-full bg-siteRed">
										School Bus Service
									</div>
								</div>
								<div class="w-1/2 mb-4">
									<div class="p-3 mx-2 rounded-full bg-siteRed">
										Factory Transportation
									</div>
								</div>
								<div class="w-1/2 mb-4">
									<div class="p-3 mx-2 rounded-full bg-siteRed">
										Wedding Bus Service
									</div>
								</div>
								<div class="w-1/2 mb-4">
									<div class="p-3 mx-2 rounded-full bg-siteRed">
										Excursion Bus Service
									</div>
								</div>
								<div class="w-1/2 mb-4">
									<div class="p-3 mx-2 rounded-full bg-siteRed">
										Funeral Bus Service
									</div>
								</div>

							</div>
						</div>

					</div>
					
				</div>
			</div>

			<div class="section-rightchoice">
				<div class="container px-4 py-12 lg:py-24">
					<h2 class="mb-8 text-3xl font-semibold leading-tight text-center uppercase lg:text-5xl lg:mb-16 font-montserrat"><span class="text-siteRed">The Right</span> Bus Transportation <br class="hidden lg:inline-block xl:hidden">For All</h2>

					<div class="flex flex-wrap text-4xl font-bold leading-tight text-center text-white solutions sm:text-3xl md:text-4xl lg:text-2xl xl:text-4xl font-montserrat">
						<div class="w-full mb-4 sm:w-1/2 lg:w-1/4">
							<div class="h-auto mx-auto rounded-full badge">
								<div class="w-full p-8 badge-content">
									More than 30 Years
								</div>
							</div>
						</div>
						<div class="w-full mb-4 sm:w-1/2 lg:w-1/4">
							<div class="h-auto mx-auto rounded-full badge">
								<div class="w-full p-8 badge-content">
									Same Day Response
								</div>
							</div>
						</div>
						<div class="w-full mb-4 sm:w-1/2 lg:w-1/4">
							<div class="h-auto mx-auto rounded-full badge">
								<div class="w-full p-8 badge-content">
									Friendly Provider
								</div>
							</div>
						</div>
						<div class="w-full mb-4 sm:w-1/2 lg:w-1/4">
							<div class="h-auto mx-auto rounded-full badge">
								<div class="w-full p-8 badge-content">
									Well-Maintained Buses
								</div>
							</div>
						</div>

					</div>
					
				</div>

			</div>

			<div class="bg-gray-300 section-about">
				<div class="container px-4 py-8 lg:py-16">
					<h2 class="mb-8 text-3xl font-semibold leading-tight text-center uppercase lg:text-5xl lg:mb-16 font-montserrat"><span class="text-siteRed">About</span> Us</h2>

					<div class="flex flex-wrap">
						<div class="w-full mb-8 lg:mb-0 lg:w-1/2 lg:pr-4">
							<div class="about-img"></div>
						</div>
						<div class="w-full leading-snug lg:p-4 lg:w-1/2 lg:pr-0">
							<p class="mb-4">Founded in 2004 in our current entity, Johnson Transport & Trading PL (“JT&T”), with operating customised bus services locally as our main forte, our company embraces a tradition that dates back to 1975 with a heritage amassed from the sweat and toil on the ground for over 3 decades.</p>
							<p class="mb-4">Through our prominent members, we have acquired a working philosophy of providing efficient, reliable, and safe services for our customers, evolving from years of serious hard work and moulded by a sense of commitment and utmost sincerity for our customers and commuters.</p>
						</div>
					</div>

				</div>
			</div>

			<div class="section-contact">
				<div class="container px-4 py-8 lg:py-16">
					<div class="flex flex-wrap">
						<div class="w-full mb-4 leading-tight text-white lg:w-7/12 lg:pr-8 font-montserrat lg:mb-0">
							<h2 class="mb-4 text-3xl font-semibold leading-tight uppercase lg:text-5xl lg:mb-8"><span class="text-siteRed">Trusted</span> Bus Provider</h2>
							<p class="mb-2 text-lg lg:text-xl">You are welcome to call us for query</p>
							<h3 class="mb-4 text-2xl font-light lg:text-4xl">Call Us At <a href="tel:+6564631188" class="-mb-1 font-semibold tracking-wider duration-150 border-b-2 border-transparent lg:border-b-4 hover:border-current"><span>6463 1188</span></a></h3>

							<div class="flex mb-6 lg:mb-8">
								<hr class="w-1/2 border-b-4 lg:w-1/4 border-siteRed">
							</div>

							<div class="mb-8 text-lg lg:text-xl">
								<h4 class="mb-2 font-semibold">Locate Us</h4>
								<p>Johnson Transport & Trading</p>
								<p>10 Buroh Street #01-23/24, West Connect Building, Singapore 627564</p>
							</div>

							<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1994.3857389735774!2d103.70122797607566!3d1.312535981265843!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da056bd1927f43%3A0xbc0fc1ad9d6c9e66!2sWest%20Connect%20Building!5e0!3m2!1sen!2sph!4v1601525150202!5m2!1sen!2sph" width="100%" height="300" frameborder="0" style="border:0" allowfullscreen=""></iframe>
						</div>

						<div class="w-full lg:w-5/12">
							<div class="px-4 py-8 text-white lg:py-12 lg:px-8 bg-siteRed">
								<p class="mb-6 text-xl font-semibold leading-none text-center uppercase font-montserrat">Send Us Your Enquiry Today!</p>
								<!-- feedback.activamedia.com.sg script begins here -->
								<iframe allowTransparency="true" style="min-height:430px; height:inherit; overflow:auto;" width="100%" id="contactform123" name="contactform123" marginwidth="0" marginheight="0" frameborder="0" src="//feedback.activamedia.com.sg/my-contact-form-5661262.html"></iframe>
								<!-- feedback.activamedia.com.sg script ends here -->
							</div>
						</div>
					</div>

				</div>
			</div>

		</div>

		<SiteFooter />

	</div>
</template>

<script>
// @ is an alias to /src
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'

export default {
	name: 'Home',
	components: {
		SiteHeader,
		SiteFooter,
	},
}
</script>

<style scoped lang="scss">
	[class*="section-"] {
		@apply bg-center bg-no-repeat bg-cover;
	}

	.section-mainbanner {
		background-image: url('/mainbanner-bg01.jpg');
	}
	.section-services {
		.services-img {
			background-image: url('/services-img01.jpg');
			@apply bg-no-repeat bg-cover;
			height: 24rem;
			background-position: center 25%;
		}
	}
	.section-rightchoice {
		background-image: url('/rightchoice-bg01.jpg');
		background-position: center 75%;

		.solutions {
			.badge {
				@apply bg-siteRed;
				width: calc(100% - 2rem);
				padding-top: calc(100% - 2rem);
				position: relative;
	
				>.badge-content {
					position: absolute;
					left: 50%;
					top: 50%;
					transform: translate(-50%,-50%);
				}
			}

			>div:nth-child(even)>.badge {
				@apply bg-black;
			}
		}
	}
	.section-about {
		.about-img {
			background-image: url('/about-img01.jpg');
			@apply bg-no-repeat bg-cover;
			height: 16rem;
			background-position: center 30%;
			@screen lg {
				height: 24rem;
			}
		}
	}
	.section-contact {
		background-image: url('/contact-bg01.jpg');
	}

</style>
